import React from 'react';
import RadioButtonGroup from '../../../../../generic/Form/Compound/RadioButtonGroup';
import useFilterWrapper from '../../../../../../hooks/generic/FilterUI/useFilterWrapper';
import { useSelector, useDispatch } from '../../../../../../chronusStore/helper';
import { eventsListingActions } from '../../../../../../chronusStore/slice/eventsListing';
import { safeMutate } from '../../../../../../utils/GeneralUtils';

const Tab = ({ filterData }) => {
  const selectedTabValue = useSelector(state => state.eventsListing.filters.tab);
  const selectedTabLabel = filterData.find(data => data.value === selectedTabValue).label;
  const dispatch = useDispatch();
  const updatedFilterData = safeMutate(filterData, draftFilterData => {
    draftFilterData.find(data => data.value === selectedTabValue).checked = true;
  });

  const onChangeHandler = (_event, _childUId, childData) => {
    filterWrapperActions.filterBodyVisibilitySetter(false);
    let selectedTab = childData.find(choice => choice.checked === true)
    dispatch(eventsListingActions.updateTab(selectedTab.value));
  };

  const [FilterWrapper, filterWrapperOptions, filterWrapperActions] = useFilterWrapper({});

  return (
    <FilterWrapper
      title={ <span>{selectedTabLabel}<i className='fa-solid fa-caret-down ml-2'/></span> }
      showFilter
      rounded
      bodyClass='cui-border-radius-6'
      { ...filterWrapperOptions }
    >
      <RadioButtonGroup
        data={ updatedFilterData }
        onChange={ onChangeHandler }
      />
    </FilterWrapper>
  )
}

export default Tab;